function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.707 7.293a1 1 0 00-1.414 1.414l1.414-1.414zm7.071 9.9a1 1 0 001.414-1.415l-1.414 1.414zm-8.485-1.415a1 1 0 101.414 1.414l-1.414-1.414zm9.9-7.07a1 1 0 00-1.415-1.415l1.414 1.414zm-9.9 0l8.485 8.484 1.414-1.414-8.485-8.485-1.414 1.414zm1.414 8.484l8.485-8.485-1.414-1.414-8.485 8.485 1.414 1.414z",
  fill: "currentColor"
});

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgCross;